var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSfrxeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    style: {
      enableBackground: "new 0 0 283.46 283.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.73,283.46c-19.13,0-37.69-3.75-55.17-11.14c-16.88-7.14-32.03-17.36-45.05-30.37    c-13.01-13.01-23.23-28.17-30.37-45.05C3.75,179.42,0,160.86,0,141.73s3.75-37.69,11.14-55.17c7.14-16.88,17.36-32.03,30.37-45.05    C54.53,28.5,69.68,18.28,86.56,11.14C104.04,3.75,122.6,0,141.73,0s37.69,3.75,55.17,11.14c16.88,7.14,32.03,17.36,45.05,30.37    c13.01,13.01,23.23,28.17,30.37,45.05c7.39,17.48,11.14,36.04,11.14,55.17s-3.75,37.69-11.14,55.17    c-7.14,16.88-17.36,32.03-30.37,45.05c-13.01,13.01-28.17,23.23-45.05,30.37C179.42,279.72,160.86,283.46,141.73,283.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 141.73,
    cy: 141.73,
    r: 134.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145.03,88.34c17.93,1.6,32.04,16.45,32.48,34.69l27.51,11.43l-14.34-23.38l30.49-30.49l-18.22-18.22     L176.83,88.5l-31.79-51.84V88.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.04,129.82c-2.64,15.88-15.76,28.21-32.01,29.67v18.88l60.54-36.69L177.04,129.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.58,129.82l-28.53,11.85l60.54,36.69v-18.88C122.34,158.03,109.22,145.7,106.58,129.82z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "204.89,160.92 145.03,197.2 145.03,245.25 169.66,210.54 195.37,236.25 213.59,218.03      184.79,189.23    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "138.59,197.2 78.73,160.92 98.83,189.23 70.03,218.03 88.25,236.25 113.96,210.55 138.59,245.24         "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.6,134.47l27.51-11.43c0.44-18.24,14.55-33.09,32.48-34.69V36.66L106.8,88.5L80.67,62.37L62.45,80.6     l30.49,30.49L78.6,134.47z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.07,119.81L143.07,119.81c-8.83-2.71-8.83-4.21-8.83-5.42c0-1.68,2.54-4,7.31-4    c2.82,0,7.56,0.7,7.56,5.42h8.59c0-8.38-6.49-14.01-16.15-14.01c-10.33,0-15.9,6.49-15.9,12.59c0,8.34,7.32,11.3,14.84,13.62v0    c8.83,2.71,8.88,4.23,8.88,5.44c0,1.68-2.54,4-7.31,4c-2.83,0-7.56-0.7-7.56-5.42h-8.59c0,8.38,6.49,14.01,16.15,14.01    c10.33,0,15.9-6.49,15.9-12.59C157.97,125.1,150.6,122.12,143.07,119.81z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfrxeth);
export default __webpack_public_path__ + "static/media/sfrxeth.3f4acce8a9225f301b580c92dd31bd5b.svg";
export { ForwardRef as ReactComponent };